// Podium mirror shown when the GM reaches the game-over screen.
const MEDALS = ["🥇", "🥈", "🥉"];

const LiveGameOver = ({ state }) => {
  const teams = [...(state?.over?.finalTeams || state?.teams || [])].sort(
    (a, b) => (b.points || 0) - (a.points || 0)
  );
  const winnerNames = state?.over?.winnerNames || [];

  return (
    <div
      className="w-full h-[89vh] flex flex-col items-center justify-center gap-6 p-6 bg-gradient-to-br from-background via-behindButton to-background"
      style={{ direction: "rtl" }}
    >
      <h1 className="text-mainText text-3xl md:text-4xl font-bold">
        🎉 انتهت اللعبة
      </h1>
      {winnerNames.length > 0 && (
        <p className="text-white text-lg md:text-2xl font-bold">
          الفائز: {winnerNames.join(" و ")}
        </p>
      )}
      <div className="w-full max-w-md flex flex-col gap-2">
        {teams.map((team, i) => (
          <div
            key={team.id}
            className={`flex flex-row justify-between items-center rounded-xl px-4 py-3 font-bold text-white
              ${i === 0 ? "bg-mainButton ring-2 ring-mainText" : "bg-brown/80"}`}
          >
            <span>
              {MEDALS[i] || `${i + 1}.`} {team.name}
            </span>
            <span className="text-mainText">{team.points}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveGameOver;
